import { APP_STORAGE } from "../_Config/AppConfig.Storage";

export const STORAGE_SESSION_HELPER = {

    GET_STORAGE: (key) => {
        return sessionStorage.getItem(key) || localStorage.getItem(key);
    },

    SET_STORAGE: (key, value) => {
        localStorage.setItem(key, value);
    },

    SET_SESSION_STORAGE: (key, value) => {
        sessionStorage.setItem(key, value);
    },

    REMOVE_STORAGE: (key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    },

    CLEAR_AUTH: () => {
        // Limpiamos... ["TOKEN_USER_AUTH", "TOKEN_USER_REFRESH", ...]
        Object.values(APP_STORAGE).forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    }

};